import React from "react";
import { useNavigate } from "react-router-dom";
import { ConfigureOpsData } from "../../../../data/DataFile";
import "./HubHeader.scss";

interface HubHeaderProps {
  className?: string;
  title?: string;
  description?: string;
  showBackButton?: boolean;
  backRoute?: string;
  onBack?: () => void;
}

const HubHeader: React.FC<HubHeaderProps> = ({
  className,
  title = ConfigureOpsData.title,
  description = ConfigureOpsData.description,
  showBackButton = false,
  backRoute,
  onBack
}) => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    if (onBack) {
      onBack();
    } else if (backRoute) {
      navigate(backRoute);
    } else {
      window.history.back();
    }
  };

  return (
    <div className={`hub-header ${className || ""}`}>
      <div className="title">
        {showBackButton && (
          <div className="back-row">
            <button className="back-button" onClick={handleBackClick}>
              <svg
                className="back-icon"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M10 19l-7-7m0 0l7-7m-7 7h18"
                />
              </svg>
              <span>Back</span>
            </button>
          </div>
        )}
        <div className="title-row">
          <h1>{title}</h1>
          <div className="dots">
            <div className="dot-yellow" />
            <div className="dot-yellow" />
            <div className="dot-dark-yellow" />
          </div>
        </div>
        <p>{description}</p>
      </div>
      {/* <button
        className="action-button"
        onClick={() => navigate("/view-summary")}
      >
        <svg
          className="eye-icon"
          fill="currentColor"
          viewBox="0 0 20 20"
          style={{ width: "1rem", height: "1rem", marginRight: "0.5rem" }}
        >
          <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
          <path
            fillRule="evenodd"
            d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
            clipRule="evenodd"
          />
        </svg>
        <span style={{ marginRight: "0.5rem" }}>{ConfigureOpsData.action}</span>
        <span>▾</span>
      </button> */}
    </div>
  );
};

export default HubHeader;
